module.exports = __webpack_public_path__ + "img/68_39.1829a8ae.png";